module.exports = __webpack_public_path__ + "img/tusdc.1671a01d.png";